import { routes } from "./routes";

export const navbarItems = [
  {
    title: "Log In",
    path: routes.Login,
  },
];

export const loggedNavbarItems = [
  {
    title: "My Profile",
    path: routes.UserProfile,
  },
  {
    title: "City",
    path: routes.CitySelector
  }
];